import { getStore } from "../store/store";

export function isSignInRequired(): boolean {
    return getStore().isSignInRequired;
}
